import React from 'react';
import Sidebar from '../components/Sidebar';
import EmailTemplateEditor from '../components/EmailTemplateEditor';

export default function OwnerEmailTemplates() {
  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-main">
        <h1 style={{ fontSize: '22px', fontWeight: 700, marginBottom: '4px' }}>Email Templates</h1>
        <p style={{ color: '#6b7280', fontSize: '13px', marginBottom: '24px' }}>
          Customise the notification emails sent to brokers and introducers.
        </p>
        <EmailTemplateEditor />
      </main>
    </div>
  );
}
